import { Component, OnInit } from '@angular/core';
import { QuestionService } from 'src/app/service/question.service';
import { AnswerService } from 'src/app/service/answer.service';
import { NotifierService } from 'angular-notifier';
@Component({
  selector: 'app-counter-type',
  templateUrl: './counter-type.component.html',
  styleUrls: ['./counter-type.component.scss']
})
export class CounterTypeComponent implements OnInit {
  public ansBody:any = {
    question_label:'',
    question_name:'',
    answer_text:[],
  }
  public format_counter_option:any = [];
  public componentType:string = "";
  constructor(
    public qService:QuestionService,
    public aService:AnswerService,
    public notifier:NotifierService,
  ) {
    this.componentType = this.qService.questionType.COUNTER_TYPE
    this.qService.refreshAnsBody
    .subscribe((question_type:string) =>{
      if (question_type == this.componentType) {
        this.resetAnsBody();
      }
    })
   }

  ngOnInit(): void {
    this.formatCounter();
  }


  formatCounter()
  {
    // let arr = this.qService.currentQuestion.options.map((va:any) => ({'id':va.id,'text':va.text,'misc':{'rank':0,'localText':va.text}}));
    let arr = this.qService.currentQuestion.options.map((va:any) => ({'id':va.id,'text':va.text,'misc':{'rank':va.miscellaneous.misc.min?va.miscellaneous.misc.min:0,
    'localText':va.text,
    'min':va.miscellaneous.misc.min?va.miscellaneous.misc.min:0,'max':va.miscellaneous.misc.max,
    'interval':va.miscellaneous.misc.interval,'required':va.miscellaneous.misc.required
  }}));
    this.format_counter_option = arr;
    // console.log(this.format_counter_option);
  }

  next(){
    this.ansBody.question_label = this.qService.currentQuestion.question_label;
    this.ansBody.question_name = this.qService.currentQuestion.question_name;
    this.ansBody.answer_text = this.format_counter_option;
    this.aService.submitAnswer(this.ansBody);
    // this.resetAnsBody()
    // setTimeout(() => {
    //   this.resetAnsBody();
    // }, 100);
  }

  decreaseCount(index:number){
    if (this.format_counter_option[index]["misc"]["min"] < this.format_counter_option[index]["misc"]["rank"]) {
      this.format_counter_option[index]["misc"]["rank"]--
    }else{
      this.notifier.notify('success',"Reached to the MIN limit")
    }
  }

  increaseCount(index:number){
    if ((this.format_counter_option[index]["misc"]["max"] > this.format_counter_option[index]["misc"]["rank"] )|| !this.format_counter_option[index]["misc"]["max"]) {
      this.format_counter_option[index]["misc"]["rank"]++
    }else{
      this.notifier.notify('success',"Reached to the MAX limit")
    }
  }

  resetAnsBody(){
    this.ansBody ={
      question_label:'',
      question_name:'',
      answer_text:[],
    }
  }
}
